import React from "react";
import ReactDOM from "react-dom";
import "./AlertManager.css";

class AlertManager {
  static show({ type = "message", title = "", message = "", buttonText = "OK", onClose }) {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const closeAlert = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      if (onClose) onClose();
    };

    const AlertModal = () => (
      <div className="alert-backdrop">
        <div className="alert-card">
            <button className="alert-close-btn" onClick={closeAlert}>×</button>
        <div className="alert-title-plus-tag">
          <div className={`alert-tag alert-${type}`}>{type.toUpperCase()}</div>
          {title && <h2 className="alert-title">{title}</h2>}
        </div>
          <p className="alert-text">{message}</p>
          <button className="alert-btn" onClick={closeAlert}>
            {buttonText}
          </button>
        </div>
      </div>
    );

    ReactDOM.render(<AlertModal />, container);
  }

  static confirm({ title = "Confirm", message = "", onConfirm, onCancel }) {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const close = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };

    const ConfirmModal = () => (
      <div className="alert-backdrop">
        <div className="alert-card">
            <button className="alert-close-btn" onClick={close}>×</button>
            <div className="alert-title-plus-tag">
                <div className="alert-tag alert-warning">CONFIRM</div>
                {title && <h2 className="alert-title">{title}</h2>}
            </div>
          <p className="alert-text">{message}</p>
          <div className="alert-btn-group">
            <button className="alert-btn cancel" onClick={() => { close(); onCancel?.(); }}>Cancel</button>
            <button className="alert-btn" onClick={() => { close(); onConfirm?.(); }}>Confirm</button>
          </div>
        </div>
      </div>
    );

    ReactDOM.render(<ConfirmModal />, container);
  }
}

export default AlertManager;
